import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: Record<string, GenericFormItem[]> = {
  simple: [
    {
      gridXs: 12,
      label: i18n.t('APPLICATIONS_PAGE.APPLICATION_NAME_KEY'),
      stateKey: 'name',
      validateOnChange: true,
    },
  ],
  advanced: [
    {
      gridXs: 12,
      label: i18n.t('APPLICATIONS_PAGE.APPLICATION_NAME_KEY'),
      stateKey: 'name',
      validateOnChange: true,
    },
    {
      gridXs: 12,
      label: i18n.t('APPLICATIONS_PAGE.APPLICATION_ADDRESS_KEY'),
      stateKey: 'application_path',
      validateOnChange: true,
    },
    {
      gridXs: 12,
      label: i18n.t('APPLICATIONS_PAGE.STARTUP_PARAMETER_KEY'),
      stateKey: 'application_parameters',
      validateOnChange: true,
    },
    {
      gridXs: 12,
      label: i18n.t('APPLICATIONS_PAGE.DISPLAY_APPLICATION_NAME_KEY'),
      stateKey: 'display_name',
      validateOnChange: true,
    },
  ],
};

export default fields;
